
dataTableDirective = ($parse, $state) ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'util/widgets/dataTable'
    scope: true
    link: (scope, element, attrs) ->
        scope.table = {}
        scope.table.columns = []

        scope.$watch attrs.tableData, (data) ->
            scope.table.data = data

        if attrs.totalData
            scope.table.hasTotal = true
            scope.$watch attrs.totalData, (totals) ->
                scope.table.totals = totals

        scope.columnLink = (column, item) ->
            stateName = attrs[column.normalized + 'Link']
            stateParams = $parse(attrs[column.normalized + 'LinkParams']) \
                scope, item: item
            $state.go(stateName, stateParams)

        for name, index in attrs.columnNames.split(',')
            scope.table.columns.push new Column($parse, name, scope, attrs)


class Column

    constructor: (@parse, @name, @scope, @attrs) ->
        @propertyMeta = {}
        @normalized = @attrs.$normalize(@name.replace('_', '-'))

        @initializeProperty('Label', capitalizeColumnName)
        @initializeProperty('Weight', -> 1)

        @hasLink = @attrs[@normalized + 'Link']

        @dataExpression = if @attrs[@normalized] \
            then @parse(@attrs[@normalized]) \
            else (scope, extra) =>
                extra.item[@name]

        @totalExpresion = if @attrs[@normalized + 'Total'] \
            then @parse(@attrs[@normalized + 'Total']) \
            else @dataExpression

    Object.defineProperties @prototype,
        label: get: -> @getProperty('Label')
        weight: get: -> @getProperty('Weight')

    toJSON: ->
        name: @name
        normalized: @normalized
        label: @label
        weight: @weight

    literalAttr: (name) -> @attrs["#{@normalized}#{name}"]
    expressionAttr: (name) -> @attrs["#{@normalized}#{name}Exp"]

    initializeProperty: (name, makeDefault=angular.noop) ->
        meta = {}

        if @expressionAttr name
            meta.type = 'exp'
            meta.expression = @parse(@expressionAttr name)

        else if @literalAttr name
            meta.type = 'attr'

        else
            meta.type = 'literal'
            meta.value = makeDefault(@name, name)

        @propertyMeta[name] = meta

        return

    getProperty: (name, extra) ->
        meta = @propertyMeta[name]

        switch meta.type
            when 'attr' then @literalAttr name
            when 'exp' then meta.expression @scope, extr
            else meta.value

    getData: (item) ->
        return @dataExpression @scope,
            item: item
            value: item[@name]

    getTotalData: (item) ->
        return @totalExpresion @scope,
            item: item
            value: item[@name]

capitalizeColumnName = (name) ->
    skip = ['of', 'and']
    parts = (capitalizeFirstLetter(word) \
        for word in name.split('_') \
        when word not in skip)
    return parts.join(" ")


capitalizeFirstLetter = (word) -> word[0].toUpperCase() + word[1..word.length]

module.directive('dybTable', dataTableDirective)
